import { render } from "./DeletePropertiesModal.vue?vue&type=template&id=bdbc7744"
import script from "./DeletePropertiesModal.vue?vue&type=script&lang=js"
export * from "./DeletePropertiesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__